import React, { Component } from 'react';
import RenderInBody from 'components/shared/render_in_body';
import trackEvent from 'misc/trackEvent';
import MicroFeedbackPopover from './MicroFeedbackPopover';

export const MICRO_FEEDBACK_SUBMIT_EVENT = 'micro-feedback:submit';

class MicroFeedback extends Component {
  state = {
    hasSelection: false,
    selectionRect: null,
    selectionText: '',
  };

  contentEl = document.querySelector('.lesson_viewer');

  componentDidMount() {
    document.addEventListener('selectstart', this.registerSelection);
    document.addEventListener('selectionchange', this.closeOnSelectionCollapse);
    window.addEventListener('resize', this.closePopover);

    // These two events limit the selection scope to the lesson content only
    document.addEventListener('mouseup', this.cancelSelection);
    this.contentEl.addEventListener('mouseup', this.handleSelection);
  }

  componentWillUnmount() {
    document.removeEventListener('selectstart', this.registerSelection);
    document.removeEventListener(
      'selectionchange',
      this.closeOnSelectionCollapse,
    );
    window.removeEventListener('resize', this.closePopover);
    document.removeEventListener('mouseup', this.cancelSelection);
    this.contentEl.removeEventListener('mouseup', this.handleSelection);
  }

  registerSelection = e => {
    if (this.contentEl.contains(e.target)) {
      this.selectionStarted = true;
    }
  };

  /**
   * Cancel selection if the mouse up event was fired outside the lesson content
   * (e.g. selection the entire page). The propagation of this event will be
   * blocked by the `mouseup` handler on the lesson container.
   */
  cancelSelection = () => {
    this.selectionStarted = false;
  };

  closePopover = () => {
    if (this.state.hasSelection) {
      this.setState({ hasSelection: false, selectionRect: null });
    }
  };

  closeOnSelectionCollapse = () => {
    if (document.getSelection().isCollapsed) {
      this.closePopover();
    }
  };

  handleSelection = e => {
    if (!this.selectionStarted) {
      return;
    }

    this.selectionStarted = false;

    e.stopPropagation();

    const selection = window.getSelection();
    const selectionText = selection.toString().trim();
    if (!selectionText) return;

    const range = selection.getRangeAt(0).cloneRange();
    const selectionRect = range.getBoundingClientRect();

    this.setState({
      hasSelection: true,
      selectionText,
      selectionRect,
    });
  };

  handleClick = () => {
    const { selectionText } = this.state;
    const { lessonId, sectionId } = this.props;
    pubsub.publish(MICRO_FEEDBACK_SUBMIT_EVENT, selectionText);
    trackEvent('micro_feedback/popup_clicked', {
      section_id: sectionId,
      lesson_id: lessonId,
      selected_text: selectionText,
    });
    this.closePopover();
  };

  render() {
    const { hasSelection, selectionRect } = this.state;
    return (
      hasSelection && (
        <RenderInBody>
          <MicroFeedbackPopover
            selectionRect={selectionRect}
            onClick={this.handleClick}
          />
        </RenderInBody>
      )
    );
  }
}

export default MicroFeedback;
